import { render, staticRenderFns } from "./NewMaterialDialog.vue?vue&type=template&id=4d7f88ae"
import script from "./NewMaterialDialog.vue?vue&type=script&lang=ts"
export * from "./NewMaterialDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports